import React from "react";
import { IconName, IconPrefix } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.scss";
import { NavLink } from "react-router-dom";

export interface MenuItemInterface {
    label: any;
    value: string;
    path: string;
    icon: string;
    iconPrefix?: IconPrefix;
}

interface MenuProps {
    items: MenuItemInterface[];
    style?: "dark" | "light";
}

const Menu = (props: MenuProps) => {
    return (
        <div className={`vapor_menu vapor_menu-${props.style}`}>
            {props.items.map((item) => (
                <NavLink to={{ pathname: item.path }}>
                    <div
                        key={`vapor_menu-item-${item.value}`}
                        className="vapor_menu-item"
                    >
                        <FontAwesomeIcon
                            icon={[
                                item.iconPrefix || "far",
                                item.icon as IconName,
                            ]}
                        />
                        <span>{item.label}</span>
                    </div>
                </NavLink>
            ))}
        </div>
    );
};

Menu.defaultProps = {
    style: "dark",
};

export default Menu;
